<template>
  <div class="signup">
    <b-container fluid >
      <b-row align-h="center">
        <b-col cols="15" sm="5">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <h6 class="mb-0">Sign up</h6>
            </template>
            <b-form-group
              id="input-group-1"
              label="E-mail"
              class="label"
              label-for="email"
            >
              <b-form-input
                id="email-input"
                type="email"
                v-model="email"
                required
                placeholder="Enter your email..."
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="Password"
              class="label"
              label-for="password"
            >
              <b-input-group>
                <b-form-input
                  id="password-input"
                  :type="fieldType"
                  v-model="password"
                  required
                ></b-form-input>
                <b-input-group-append>
                  <b-button v-on:mousedown="viewPassword" v-on:touchstart="viewPassword" v-on:touchend="hiddenPassword" v-on:mouseup="hiddenPassword">
                    <font-awesome-icon v-if="fieldType === 'password'" :icon="['fas','eye']" size="s" />
                    <font-awesome-icon v-if="fieldType === 'text'" :icon="['fas','eye-slash']" size="s" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div class="terms">
              <TermsOfService></TermsOfService>
            </div>
            <b-form-checkbox v-model="accept">I accept the Terms of Service</b-form-checkbox>
            <b-button class="signup-btn" @click="reset" variant="danger">Cancel</b-button>
            <b-button class="signup-btn" :disabled="!accept" v-b-modal.confirm-1 variant="primary">Sign up</b-button>
            <template v-slot:footer>
              <b-link to="/signin">Do you have an account? Please sign in.</b-link>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="confirm-1"
      title="Confirmation!"
      ok-title="Regist"
      @ok="signUp"
    >
      <h6>Please confirm email.</h6>
      <h4>{{ email }}</h4>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase'
import TermsOfService from './TermsOfService.vue'
export default {
  name: 'Signup',
  components: {
    TermsOfService,
  },
  data () {
    return {
      email: '',
      password: '',
      fieldType: 'password',
      accept: 'false'
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    reset: function () {
      this.email = ''
      this.password = ''
      this.stay = true
    },
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(() => {
        var user = firebase.auth().currentUser
        user.sendEmailVerification().then(() => {
          this.makeToast('success', 'Send verification email to ' + user.email)
          this.reset()
          this.$router.push('/signin')
        }).catch((error) => {
          this.makeToast('danger', 'Failed to send verification email to ' + user.email + error)
          this.reset()
        })
      }).catch(error => {
        this.makeToast('danger', 'Failed to create user.' + error)
         this.reset()
      })
    },
    viewPassword: function () {
      this.fieldType = 'text'
    },
    hiddenPassword: function () {
      this.fieldType = 'password'
    }
  }
}
</script>

<style>
.signup {
  margin: 32px
}
.signup-btn {
  margin: 10px
}
.label {
  text-align: left
}
.terms {
  max-height: 100px;
  overflow: auto;
  border-width: 1px;
  border-style: solid;
  border-color: #bdbdbd;
}
</style>

